export default {
    edit: 'Redigera',
    location: 'Plats + V&C',
    filter: 'Filter',
};
